import "./App.css";
import RouterWrapper from "./RouterWrapper";

function App() {
  return (
    <div className="App">
      <RouterWrapper />
    </div>
  );
}

export default App;
